import ApiceFadeIn from "../../lib_react_frontend/componentes/ApiceFadeIn.jsx";
import React from "react";
import { connect } from "react-redux";
import constants from "../../constants.js";

import SideImagem from "../../imagens/ApiceFechamento.png";

/**
 * Tela de login padrão utilizada nos sistemas, é possível passar uma cor
 * para ele de forma a customizar ela.
 */
class TelaLogout extends React.Component {
    constructor() {
        super();

        // Padrão do LTE:
        document.body.className = "hold-transition login-page";
    }

    /**
     * @override
     */
    componentDidMount() {
        this.apiceFadeIn.fadeIn();
        if (this.props.focusFieldRef) {
            setTimeout(() => {
                this.props.focusFieldRef(); 
            }, 0); 
        }
    }

    renderBody() {

        const nome1 = global.app.nomeAplicacao.split(" ")[0];
        const nome2 = global.app.nomeAplicacao.split(" ")[1];
        const nome3 = global.app.nomeAplicacao.split(" ")[2];
        return (
            <div className="login-box">
                {/* Header: */}
                {global.app.usaImagem ? (
                    <div className="login-logo wx-250 hx-50 bg25s" />
                ) : (
                    <div className="login-logo hx-50" style={{ margin: 0 }}>
                        <i className={"fa rxzz " + global.app.icone} />
                        <b>{nome1}</b> {nome2} <b>{nome3}</b>
                    </div>
                )}
                {global.app.subNomeAplicacao && (
                    <div
                        className="row"
                        style={{
                            float: "center",
                            fontSize: "20px",
                            textAlign: "center",
                        }}
                    >
                        {global.app.subNomeAplicacao}
                    </div>
                )}
                <div className="row"
                    style={{
                        float: 'center',
                        fontSize: '20px',
                        paddingBottom: '5px',
                        textAlign: 'center'
                    }} >
                    <p >Realize o Downlaod dos Fechamentos Mensais</p>
                </div>
                {this.props.renderBody()}

                <div id="ttt" style={{ textAlign: "center", fontSize: '20px', marginTop: "10px" }} className="login-text">
                    <b>
                        <a target="_blank" href="http://apicesistemas.com.br/">
                            {constants.textInicial}
                        </a>
                    </b>
                </div>
                <div className="login-text">
                    <p style={{ fontSize: "20px", textAlign: "center" }}>
                        {constants.versao && constants.versao}
                    </p>
                </div>
            </div>
        )
    }


    render() {

        return (
            <ApiceFadeIn ref={(e) => (this.apiceFadeIn = e)}>
                <div
                    style={{
                        display: "flex",
                        height: "100vh",
                        width: "100vw",
                        overflow: "hidden"
                    }}
                >
                    {/* Metade da Imagem: */}
                    <div
                        style={{
                            flex: 6,
                            backgroundSize: "cover",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "white",
                        }}
                    >
                        <img src={SideImagem} alt="" style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "cover",
                        }} />
                    </div>
                    {/* Metade do Body: */}
                    <div
                        style={{
                            flex: 4,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#F0F0F0",

                        }}
                    >

                        {this.renderBody()}
                    </div>
                </div>
            </ApiceFadeIn>
        );
    }
}

export default connect(
    (state) => ({
        socket: state.socket,
    }),
    (dispatch) => ({
        dispatch,
    })
)(TelaLogout);




// WEBPACK FOOTER //
// ./src/lib_react_adminlte/componentes/TelaLogout.jsx